import React, { Component } from 'react';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

export default class index extends Component {
    render() {
        return (
            <div id={this.props.id ? this.props.id :""} className="confirm-btn" onClick={this.props.onClickEvent} >
                {this.props.name}
                <img src={`${publicRuntimeConfig.staticFolder}/images/Right-Round-Arrow.svg`} alt="Go Next" className="confirm-img" />
            </div>
        )
    }
}
